import Head from 'next/head';
import { CDN_CLRSAVE_URL } from '../constants';

interface Props {
  title: string;
  description: string;
  canonicalUrl: string;
  keywords?: string;
  schemaObject?: any;
}

const NextHead = ({
  title,
  description,
  canonicalUrl,
  keywords = '',
  schemaObject = {
    conversion_rate: '1',
    base_currency: [{ currency_code: 'INR' }],
    target_currency: [{ currency_code: 'USD' }],
  },
}: Props) => {
  const { conversion_rate, base_currency, target_currency } = schemaObject;
  return (
    <Head>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonicalUrl} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta name="Author" content="ClearTax" />
      <meta property="og:url" content={canonicalUrl} />
      <meta name="keywords" content={`${keywords}`} />
      <meta
        property="og:image"
        content={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/OG-images-01.png`}
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:site" content="@ClearTax_In" />
      <meta name="twitter:domain" content="https://cleartax.in" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta
        name="twitter:image:src"
        content={`${CDN_CLRSAVE_URL}/clearsave-frontend/images/OG-images-01.png`}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: `{
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "${title}",
        "description": "${description}",
        "url" : "${canonicalUrl}",
        "publisher": {
          "@type": "Organization",
          "name": "ClearTax",
          "url" : "https://cleartax.in/",
          "logo" : {
            "@type": "ImageObject",
            "contentUrl": "${CDN_CLRSAVE_URL}/clearsave/images/clear_invest_logo.png"
          }
        }
      }`,
        }}
      />
      <script src="https://www.google.com/recaptcha/api.js?render=6LfK4iEdAAAAAL7byvIpTz9LlQKVbZkg0SI3ZO1Z"></script>

      {canonicalUrl && canonicalUrl.includes('currency') ? (
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org',
              '@type': 'WebApplication',
              name: 'Live Currency Converter With Latest Foreign Exchange Rates',
              description:
                'Use ClearTax Currency Converter to convert all Major World Currencies and check foreign exchange rates online. This is a free currency converter with historical currency charts and latest exchange rates.',
              url: 'https://cleartax.in/currency/currency-converter',
              applicationCategory: 'FinanceApplication',
              browserRequirements: 'Supports all major web browsers.',
              operatingSystem: 'All',
              aggregateRating: {
                '@type': 'AggregateRating',
                ratingValue: '4.95',
                ratingCount: '141',
                reviewCount: '31',
                bestRating: '5',
                worstRating: '4',
              },

              mainEntity: {
                '@type': 'ItemList',
                name: `${base_currency[0].currency_code} to ${target_currency[0].currency_code}`,
                itemListElement: {
                  '@type': 'ExchangeRateSpecification',
                  currency: `${base_currency[0].currency_code}`,
                  currentExchangeRate: {
                    '@type': 'UnitPriceSpecification',
                    price: `${conversion_rate}`,
                    priceCurrency: `${target_currency[0].currency_code}`,
                  },
                },
              },
            }),
          }}
        />
      ) : (
        ''
      )}
    </Head>
  );
};

export default NextHead;



// WEBPACK FOOTER //
// ./components/nextHead.tsx